import { render } from "./Complain.vue?vue&type=template&id=660f8e50"
import script from "./Complain.vue?vue&type=script&lang=js"
export * from "./Complain.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__